import {ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BehaviorSubject, firstValueFrom, Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import {SideNav, TableDataSource, Jig, DevicesClient, GetJigs} from 'shared';
import {NgrxBusy, withBusy} from 'ngrx-busy';
import {JigFormComponent} from "./jig-form/jig-form.component";

@Component({
  selector: 'app-jigs',
  templateUrl: './jigs.component.html',
  styleUrls: ['./jigs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JigsComponent implements OnInit, OnDestroy {

  @ViewChild(NgrxBusy, {static: true}) busy: NgrxBusy;

  private readonly unsubscribe$ = new Subject();
  private refresh$ = new BehaviorSubject(true);

  dataSource = new TableDataSource<Jig>();

  constructor(private devicesClient: DevicesClient,
              private sidenav: SideNav) {
  }

  ngOnInit(): void {
    this.refresh$.pipe(
      switchMap(() => this.devicesClient.getJigs(new GetJigs())),
      withBusy(() => this.busy),
      takeUntil(this.unsubscribe$)
    ).subscribe(data => this.dataSource.data = data);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  async openForm(jig?: Jig): Promise<void> {
    const result = await firstValueFrom(this.sidenav.open(JigFormComponent, {data: jig})
      .beforeClosed());
    if (!result) return;
    this.refresh$.next(true);
  }
}
